// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__DWSw6","green":"Layout_green__h2kuX","headerContainer":"Layout_headerContainer__AidJh","pink":"Layout_pink__Q2hoV","blue":"Layout_blue__RnTjO"};